import { common as enCommon } from './en/common';
import { common as idCommon } from './id/common';

const messages = {
  en: {
    common: enCommon,
  },
  id: {
    common: idCommon,
  },
};

export default messages;
